import HeaderTitle from './header_title';

export default HeaderTitle;
